module.exports = __webpack_public_path__ + "img/CRT_P2_Sword-006.b6a2968f.png";